export const AppPreferenceItem = {
  FundRaise: 'raiseFund',
  InKindDonation: 'inKindDonation',
  Donation: 'donation',
  Volunteer: 'volunteer',
  EmployerMatching: 'employerMatching',
  Celebration: 'celebration',
  SingleSignOn: 'sso',
  LiveCampaigns: 'liveCampaigns',
  GiftOfGiving: 'giftOfGiving',
  P2PFundRaise: 'p2pRaiseFund',
  Project: 'project',
  CrowdFunding: 'crowdFunding',
  Groups: 'groups',
  WhatsApp: 'whatsapp',
};

export const dummy = '';
